import { useMutation, useQueryClient } from '@tanstack/react-query';
import { experimentalUploadChapterImage } from '@/api';
import camelcaseKeys from 'camelcase-keys';
import chapterKeys from '@queries/chapter/chapterKeys';

const transform = (data) => {
    // TODO: Do camelcase transformation in Axios interceptor
    return camelcaseKeys(data, { deep: true });
};

const mutationFn = async ({ chapterId, image }) => {
    const { data } = await experimentalUploadChapterImage(chapterId, image);

    return transform(data);
};

const useAddChapterImageMutation = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn,
        onSuccess: (data, { chapterId, episodeId }) => {
            queryClient.invalidateQueries({
                queryKey: chapterKeys.detailById(chapterId),
            });
            // If we have an episode ID, we invalidate the full list of chapters for that episode
            if (episodeId) {
                queryClient.invalidateQueries({
                    queryKey: chapterKeys.listByEpisodeId(episodeId),
                });
            }
        },
    });
};

export default useAddChapterImageMutation;
